import { defineMessages } from 'react-intl';

export const messages: {
	expandCardLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noBuildsTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noBuildsDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	tabLabelWithStep: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	expandCardLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.expand-card-label',
		defaultMessage: 'Expand card',
		description:
			'Accessibility label (aria-label) for an expand icon button in the Studio solution build plan card within the AI conversation interface. Shown as a screen reader announcement when the button is focused or hovered. When clicked, it expands the collapsed card to reveal its full content. The purpose is to provide accessible information about the expand action for users with assistive technologies.',
	},
	noBuildsTitle: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.no-builds-title',
		defaultMessage: 'No builds available',
		description:
			'Title text displayed in an empty state within the Studio solution build plan card in the AI conversation interface when no builds are available for the solution. Shown as the heading of an empty state message. The purpose is to immediately communicate to the user that there are no builds to display for the selected solution.',
	},
	noBuildsDescription: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.no-builds-description',
		defaultMessage: 'No builds available for this solution',
		description:
			'Description text displayed in an empty state within the Studio solution build plan card in the AI conversation interface when no builds are available for the solution. Shown as the body text of an empty state message below the title. The purpose is to provide additional context explaining that the current solution does not have any builds configured or available.',
	},
	moreButtonLabel: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.more-button-label',
		defaultMessage: 'More',
		description:
			'Label for a button that appears in the Studio solution build plan card tab bar when there are too many tabs to fit within the available container width. Clicking the button reveals additional tabs that have been hidden due to space constraints.',
	},
	tabLabelWithStep: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.tab-label-with-step',
		defaultMessage: 'Step {stepNumber}: {label}',
		description:
			'Label for a build tab in the Studio solution build plan card, showing the step number and the build name. The stepNumber placeholder will be substituted with the step number (e.g., "1", "2"). The label placeholder will be substituted with the build name.',
	},
});
